import { render, staticRenderFns } from "./e-tank.vue?vue&type=template&id=2839ffae&scoped=true&"
import script from "./e-tank.vue?vue&type=script&lang=js&"
export * from "./e-tank.vue?vue&type=script&lang=js&"
import style0 from "./e-tank.vue?vue&type=style&index=0&id=2839ffae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2839ffae",
  null
  
)

export default component.exports